import React from 'react';
import { components } from 'react-select';
import { Lock } from 'components/SvgIcons';

export default (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Lock />
            </components.DropdownIndicator>
        )
    );
};
